import displayHelper from "@/util/display_helper"
import datetimeHelper from "@/util/datetime_helper"

export default function (copy) {
  let object;
  if (copy) {
    object = JSON.parse(JSON.stringify(copy));
  } else {
    object = {
      requestInProgress: false,
      lastFullReportTime: "",
      houseNumber: "",
      accountNumber: "",
      providerAccountId: "",
      providerUserId: "",
      internetServiceEntity: "",
      ataVoice: "",
      currentBillRun: "",
      nextBillDate: "",
      ratePlan: "",
      diagnostics: {
        ipAddressv4: "",
        ipAddressv6: "",
        isOnline: true,
        internetServiceStatus: {
          activationStatus: "",
          blockingStatus: "",
          blockingReason: "",
          throttledDateTime: "",
          throttledStatus: "",
          onlineStatus: "",
          lastSeenOnline: "",
          lastSessionId: "",
          nasIdentifier: "",
          callingStationId: "",
          radiusProfile: ""
        },
        voiceServiceStatus: {
          isSipRegistered: true,
          activationStatus: "",
          blockingStatus: "",
          localCallingArea: "",
          mappedPortNumber: "",
          password: ""
        },
        authHistory: {
          success: 0,
          failed: 0,
          dateFrom: "",
          dateTo: ""
        },
        serviceDetail: {
          cVlan: "",
          handoverLinkedId: "",
          sVlan: ""
        },
        ontDetail: {
          oltId: "",
          ontId: "",
          model: "",
          type: "",
          ontSerialNumber: ""
        },
        ontTestResult: {
          lastONTReportTime: "",
          status: "",
          port: "",
          ataPort: "",
          deviceDetected: "",
          macAddress: "",
          downloadedMBSinceMidnight: 0,
          uploadedMBSinceMidnight: 0,
          serviceStability: ""
        },
        internetUsage: [
          {
            usageBillingId: 0,
            date: "",
            hour: 0,
            status: "",
            lastCollectedTime: "",
            sessionDurationSeconds: 0,
            sentBytes: 0,
            sentMb: 0,
            receivedBytes: 0,
            receivedMb: 0,
            totalBytes: 0,
            totalMb: 0
          }
        ]
      }
    };
  }
  object.setAccountId = function setAccountId(value) {
    object.providerAccountId = value;
    return this;
  }
  object.setHouseAccountNumber = function setHouseAccountNumber(house, account) {
    object.houseNumber = house;
    object.accountNumber = account;
    return this;
  }
  object.isValid = function isValid() {
    if (this.providerAccountId) {
      return true;
    } else if (this.houseNumber && this.accountNumber) {
      return true;
    }
    return false;
  };
  object.getIsScanInProgress = function getIsScanInProgress() {
    return object.requestInProgress === true;
  },
  object.getVocusAccountId = function getVocusAccountId() {
    return object.providerAccountId ? object.providerAccountId : '---';
  };
  object.getVocusUserId = function getVocusUserId() {
    return object.providerUserId ? object.providerUserId : '---';
  };
  object.getHouseNumber = function getHouseNumber() {
    return object.houseNumber ? object.houseNumber : '---';
  };
  object.getAccountNumber = function getAccountNumber() {
    return object.accountNumber ? object.accountNumber : '---';
  };
  object.getAtaVoice = function getAtaVoice() {
    return object.ataVoice ? object.ataVoice : '---';
  }
  object.hasAtaVoice = function hasAtaVoice() {
    return object.getAtaVoice() !== '---';
  }
  object.getRatePlan = function getRatePlan() {
    return object.ratePlan ? object.ratePlan : '---';
  };
  object.isSkyRatePlan = function isSkyRatePlan() {
    return object.getRatePlan().startsWith('Sky_') && object.getRatePlan().endsWith('_DB');
  };
  object.getOntProvider = function getOntProvider() {
    let result;
    if (this.getRatePlan().includes('NGA')) {
      result = 'Chorus';
    } else if (this.getRatePlan().includes('UFF')) {
      result = 'UltrafastFibre';
    } else if (this.getRatePlan().includes('ENF')) {
      result = 'Enable';
    } else if (this.getRatePlan().includes('NPF')) {
      result = 'Northpower';
    } else {
      result = '---';
    }
    return result;
  };
  object.isNgaOrNorthPower = function isNgaOrNorthPower() {
    return (this.getRatePlan().includes('NGA') || this.getRatePlan().includes('Northpower'));
  };
  object.getScanTimeout = function getScanTimeout() {
    if (this.getRatePlan().includes('NGA') || this.getRatePlan().includes('Northpower')) {
      return displayHelper.SCAN_TIMEOUT_DEFAULT;
    } else if (this.getRatePlan().includes('UFF')) {
      return displayHelper.SCAN_TIMEOUT_1;
    }
    return displayHelper.SCAN_TIMEOUT_MAX;
  };
  object.getPollCountDown = function getPollCountDown() {
    if (this.getRatePlan().includes('NGA') || this.getRatePlan().includes('Northpower')) {
      return displayHelper.POLL_EXTEND_DEFAULT;
    } else if (this.getRatePlan().includes('UFF')) {
      return displayHelper.POLL_EXTEND_1;
    }
    return displayHelper.POLL_EXTEND_MAX;
  };
  object.formattedLastReportTime = function formattedLastReportTime() {
    return object.lastFullReportTime ? datetimeHelper.formattedDateTime(object.lastFullReportTime) : '---';
  };
  ///
  object.getDiagnostics = function getDiagnostics() {
    return object.diagnostics ? object.diagnostics : {};
  };
  object.getInternetServiceStatus = function getInternetServiceStatus() {
    return object.getDiagnostics().internetServiceStatus ? object.getDiagnostics().internetServiceStatus : {};
  };
  object.getAuthHistory = function getAuthHistory() {
    return object.getDiagnostics().authHistory ? object.getDiagnostics().authHistory : {};
  };
  object.getServiceDetail = function getServiceDetail() {
    return object.getDiagnostics().serviceDetail ? object.getDiagnostics().serviceDetail : {};
  };
  object.getVoiceServiceStatus = function getVoiceServiceStatus() {
    return object.getDiagnostics().voiceServiceStatus ? object.getDiagnostics().voiceServiceStatus : {};
  };
  object.getOntDetail = function getOntDetail() {
    return object.getDiagnostics().ontDetail ? object.getDiagnostics().ontDetail : {};
  };
  object.getOntTestResult = function getOntTestResult() {
    return object.getDiagnostics().ontTestResult ? object.getDiagnostics().ontTestResult : {};
  };
  object.getInternetUsage = function getInternetUsage() {
    return object.getDiagnostics().internetUsage ? object.getDiagnostics().internetUsage : [];
  };
  //
  //
  // getDiagnostics
  object.getIPAddress = function getIPAddress() {
    return object.getDiagnostics().ipAddressv4 ? object.getDiagnostics().ipAddressv4 : '---';
  };
  object.getIPAddressV6 = function getIPAddressV6() {
    return object.getDiagnostics().ipAddressv6 ? object.getDiagnostics().ipAddressv6 : '---';
  };
  object.getIsOnline = function getIsOnline(networkState) {
    if (networkState) {
      return object.getDiagnostics().isOnline ? true : false;
    } else {
      return object.getDiagnostics().isOnline ? object.getDiagnostics().isOnline : '---';
    }
  };
  // getInternetServiceStatus
  object.getRadiusProfile = function getRadiusProfile() {
    return object.getInternetServiceStatus().radiusProfile ? object.getInternetServiceStatus().radiusProfile : '---';
  };
  object.getRadiusRestricted = function getRadiusRestricted(networkStatus) {
    if (networkStatus) {
      return object.getInternetServiceStatus().blockingStatus ? object.getInternetServiceStatus().blockingStatus !== 'NotBlocked' ? true : false : false;
    } else {
      return object.getInternetServiceStatus().blockingStatus ? object.getInternetServiceStatus().blockingStatus !== 'NotBlocked' ? 'Yes' : 'No' : '---';
    }
  };
  object.getOnlineStatus = function getOnlineStatus(networkState) {
    if (networkState) {
      return object.getInternetServiceStatus().onlineStatus === 'Online';
    } else {
      return object.getInternetServiceStatus().onlineStatus ? object.getInternetServiceStatus().onlineStatus : '---';
    }
  };
  object.formattedLastSeenOnline = function formattedLastSeenOnline() {
    return object.getInternetServiceStatus().lastSeenOnline ? datetimeHelper.formattedDateTime(object.getInternetServiceStatus().lastSeenOnline) : '---';
  };
  object.getNasId = function getNasId() {
    return object.getInternetServiceStatus().nasIdentifier ? object.getInternetServiceStatus().nasIdentifier : '---';
  };
  object.getCallingStationId = function getCallingStationId() {
    return object.getInternetServiceStatus().callingStationId ? object.getInternetServiceStatus().callingStationId : '---';
  };

  // getAuthHistory
  object.getAuthSuccess = function getAuthSuccess() {
    return object.getAuthHistory().success ? object.getAuthHistory().success : '-';
  };
  object.getAuthFailed = function getAuthFailed() {
    return object.getAuthHistory().failed ? object.getAuthHistory().failed : '-';
  };
  object.getAuthAttempts = function getAuthAttempts() {
    return `Success: ${this.getAuthSuccess()}, Failed: ${this.getAuthFailed()}`
  };
  object.getLastAuth = function getLastAuth() {
    return object.getAuthHistory().dateTo ? datetimeHelper.formattedDateTime(object.getAuthHistory().dateTo) : '---';
  };
  object.getReportingPeriod = function getReportingPeriod() {
    return (object.getAuthHistory().dateFrom && object.getAuthHistory().dateTo) ?
      `Last ${datetimeHelper.formattedDayDifference(
      object.getAuthHistory().dateFrom,
      object.getAuthHistory().dateTo)} days` :
      '---';
  };

  // service detail
  object.getSVlan = function getSVlan() {
    return object.getServiceDetail().sVlan ? object.getServiceDetail().sVlan : '---';
  };
  object.getCVlan = function getCVlan() {
    return object.getServiceDetail().cVlan ? object.getServiceDetail().cVlan : '---';
  };
  object.getHandoverLinkId = function getHandoverLinkId() {
    return object.getServiceDetail().handoverLinkedId ? object.getServiceDetail().handoverLinkedId : '---';
  };
  /*
  "serviceDetail": {
      "cVlan": "55",
      "handoverLinkedId": "IDA120734442",
      "sVlan": "2006"
    },
   */
  // voice service details
/*
"voiceServiceStatus": {
            "isSipRegistered": false,
            "activationStatus": "Active",
            "blockingStatus": "NotBlocked",
            "localCallingArea": "Auckland",
            "mappedPortNumber": "",
            "password": ""
        },
 */
  object.getVoiceSipRegistered = function getVoiceSipRegistered(networkState) {
    if (networkState) {
      return object.getVoiceServiceStatus().isSipRegistered ? object.getVoiceServiceStatus().isSipRegistered === true ? true : false : false;
    } else {
      return object.getVoiceServiceStatus().isSipRegistered ? object.getVoiceServiceStatus().isSipRegistered === true ? 'Yes' : 'No' : '---';
    }
  };
  object.getVoiceActivationStatus = function getVoiceActivationStatus() {
    return object.getVoiceServiceStatus().activationStatus ? object.getVoiceServiceStatus().activationStatus : '---';
  };
  object.getVoiceBlockingStatus = function getVoiceBlockingStatus() {
    return object.getVoiceServiceStatus().blockingStatus ? object.getVoiceServiceStatus().blockingStatus : '---';
  };
  object.getVoiceLocalCallingArea = function getVoiceLocalCallingArea() {
    return object.getVoiceServiceStatus().localCallingArea ? object.getVoiceServiceStatus().localCallingArea : '---';
  };

  // ont detail
  object.getOntModel = function getOntModel() {
    return object.getOntDetail().model ? object.getOntDetail().model : '---';
  };
  object.getOntType = function getOntType() {
    return object.getOntDetail().type ? object.getOntDetail().type : '---';
  };
  object.getOntId = function getOntId() {
    return object.getOntDetail().ontId ? object.getOntDetail().ontId : '---';
  };
  object.getOltId = function getOltId() {
    return object.getOntDetail().oltId ? object.getOntDetail().oltId : '---';
  };
  object.getOntSerialNumber = function getOntSerialNumber(networkState) {
    if (networkState) {
      return object.getOntDetail().ontSerialNumber ? `S/N: ${object.getOntDetail().ontSerialNumber}` : 'S/N: ---';
    } else {
      return object.getOntDetail().ontSerialNumber ? object.getOntDetail().ontSerialNumber : '---';
    }
  };

  // ontTestResult
  object.getOntResultStatus = function getOntResultStatus(networkState) {
    if (networkState) {
      return object.getOntTestResult().status === 'Online' ? true : false;
    } else {
      return object.getOntTestResult().status ? object.getOntTestResult().status : '---';
    }
  };
  object.getOntResultPort = function getOntResultPort(networkState) {
    if (networkState) {
      return object.getOntTestResult().port ? `Port: ${object.getOntTestResult().port}` : `Port: ---`;
    } else {
      return object.getOntTestResult().port ? object.getOntTestResult().port : '---';
    }
  };
  object.getOntResultAtaPort = function getOntResultAtaPort() {
    return object.getOntTestResult().ataPort ? object.getOntTestResult().ataPort : '---';
  };
  object.getCPEDetected = function getCPEDetected(networkState) {
    if (networkState) {
      return object.getOntTestResult().deviceDetected === 'Connected device detected' ? true : false;
    } else {
      return object.getOntTestResult().deviceDetected ? object.getOntTestResult().deviceDetected === 'Connected device detected' ? 'Yes' : 'No' : '---';
    }
  };
  object.getMacAddress = function getMacAddress(networkState) {
    if (networkState) {
      return object.getOntTestResult().macAddress ? `MAC: ${object.getOntTestResult().macAddress}` : 'MAC: ---';
    } else {
      return object.getOntTestResult().macAddress ? object.getOntTestResult().macAddress : '---';
    }
  };
  object.getOntResultDownload = function getOntResultDownload() {
    return object.getOntTestResult().downloadedMBSinceMidnight ? object.getOntTestResult().downloadedMBSinceMidnight : '---';
  };
  object.getOntResultUpload = function getOntResultUpload() {
    return object.getOntTestResult().uploadedMBSinceMidnight ? object.getOntTestResult().uploadedMBSinceMidnight : '---';
  };
  object.getOntResultLastTime = function getOntResultLastTime() {
    return object.getOntTestResult().lastONTReportTime ? datetimeHelper.formattedDateTime(object.getOntTestResult().lastONTReportTime) : '---';
  };
  // internet usage
  object.formattedInternetUsageData = function formattedInternetUsageData(index) {
    const data = object.getInternetUsage()[index];
    const downloadMb = data.sentMb ? (data.sentMb/1000).toFixed(2) : 0;
    const uploadMb = data.receivedMb ? (data.receivedMb/1000).toFixed(2) : 0;
    const totalMb = data.totalMb ? (data.totalMb/1000).toFixed(2) : 0;
    return {
      dateLabel: datetimeHelper.formattedDateTimeShort(data.date),
      valueDownloadMb: Math.abs(downloadMb),
      valueUploadMb: Math.abs(uploadMb),
      valueTotal: Math.abs(totalMb),

      valueDownloadLabel: `${downloadMb > 0 ? downloadMb : Math.abs(downloadMb)+'*'}`,
      valueUploadLabel: `${uploadMb > 0 ? uploadMb : Math.abs(uploadMb)+'*'}`,
      valueTotalLabel: `${totalMb > 0 ? totalMb : Math.abs(totalMb)+'*'}`
    }
  };
  object.formattedAccountDetail = function formattedAccountDetail() {
    const result = [
      [{text: 'Vocus Account ID:', value: this.getVocusAccountId()}, {text: 'Vocus User ID:', value: this.getVocusUserId()}],
      [{text: 'House Number:', value: this.getHouseNumber()}, {text: 'Account Number:', value: this.getAccountNumber()}],
    ];
    return result;
  };
  object.formattedRadiusStatus = function formattedRadiusStatus() {
      return [
        [
          {text: 'Status:', value: this.getOnlineStatus(), style: this.getOnlineStatus(true) ? {color: 'mediumseagreen'} : {color: 'orangered'}},
          {text: 'IP Address:', value: this.getIPAddress()}],
        [{text: 'Profile:', value: this.getRadiusProfile()}, {
          text: 'Plan:',
          value: this.getRatePlan(),
          img: this.isSkyRatePlan() ? 'sky-logo.svg' : 'vocus-logo.svg'}
        ],
        [{text: 'Restricted:', value: this.getRadiusRestricted()},
          {
            text: 'Auth Attempts:',
            value: [
              {text: this.getAuthSuccess(), icon: 'check-circle-fill', style: 'color: mediumseagreen'},
              {text: this.getAuthFailed(), icon: 'exclamation-circle-fill', style: 'color: orangered'},
              {text: `(${this.getReportingPeriod()})`}
            ],
            multiple: true
          }
        ],
        [{text: 'Last Auth:', value: this.getLastAuth()}, {text: 'Last Seen:', value: this.formattedLastSeenOnline()}],
      ];
  };
  object.formattedOntResults = function formattedOntResults() {
    return [
      [
        {text: 'Status:', value: this.getOntResultStatus(), style: this.getOntResultStatus(true) ? {color: 'mediumseagreen'} : {color: 'orangered'}},
        {text: 'Serial Number:', value: this.getOntSerialNumber()}],
      [{text: 'ONT Provider:', value: this.getOntProvider()}, {text: 'ONT Type:', value: this.getOntType()}],
      [{text: 'ONT Model:', value: this.getOntModel()}, {text: 'ONT ID:', value: this.getOntId()},],
      [{text: 'Port:', value: this.getOntResultPort()}, {text: 'CPE Detected:', value: this.getCPEDetected()} ],
      [{text: 'S VLAN:', value: this.getSVlan()}, {text: 'C VLAN:', value: this.getCVlan()}],
      [{text: 'Handover:', value: this.getHandoverLinkId()}, {text: 'Last Run:', value: this.getOntResultLastTime()}],
      [{
        text: 'Usage since midnight (MB):',
        value: [
          {text: this.getOntResultDownload(), icon: 'arrow-down-circle-fill', style: 'color: dodgerblue'},
          {text: this.getOntResultUpload(), icon: 'arrow-up-circle-fill', style: 'color: mediumseagreen'}
        ],
        multiple: true
      }]
    ];
  };
  object.formattedVoiceStatus = function formattedVoiceStatus() {
    return [
      [{text: 'Voice Number:', value: this.getAtaVoice()}, {text: 'Activation Status:', value: this.getVoiceActivationStatus()}],
      [{text: 'SIP Registered:', value: this.getVoiceSipRegistered()}, {text: 'Local Calling Area:', value: this.getVoiceLocalCallingArea()}],
      [{text: 'Voice Port:', value: this.getOntResultAtaPort()}],
    ];
  };
  object.formattedNetworkMapState = function formattedNetworkMapState() {
    let states = [];
    states.push({
        key: 'router',
        state: this.getCPEDetected(true),
        value: [{label: '', value: this.formattedLastSeenOnline()}]
      },
    );
    states.push({
        key: 'ont',
        state: this.getOntResultStatus(true),
        value: [
          {label: 'S/N: ', value: this.getOntSerialNumber()},
          {label: 'Model: ', value: this.getOntModel()},
          {label: 'Port: ', value: this.getOntResultPort()}]
      },
    );
    if (this.hasAtaVoice()) {
      const ontState = states.find((state) => state.key === 'ont');
      ontState.value.push(
        {label: 'Voice Port: ', value: this.getOntResultAtaPort()}
      );
    }
    states.push({
        key: 'olt',
        state: this.getOntResultStatus(true),
        value: [{label: '', value: this.getOltId()}]
      },
    );
    states.push({
        key: 'internet',
        state: [this.getCPEDetected(true) && this.getOntResultStatus(true) && this.getIsOnline(true), this.getRadiusRestricted(true)], value: [
          {label: 'IPv4:', value: this.getIPAddress()},
          {label: 'IPv6:', value: this.getIPAddressV6()},
          {label: 'NasId:', value: this.getNasId()},
          {label: 'CallingId:', value: this.getCallingStationId()},
          {label: 'Profile:', value: this.getRadiusProfile()},
        ]
      },
    );
    states.push(
      {key: 'voice', state: [this.hasAtaVoice(), this.getVoiceSipRegistered(true)], value: [
          {label: 'Voice #:', value: this.getAtaVoice()},
          {label: 'Blocking:', value: this.getVoiceBlockingStatus()},
          {label: 'LCA:', value: this.getVoiceLocalCallingArea()},
        ]}
    )
    return states;
  };

  object.formattedUsageData = function formattedUsageData() {
    let data = [];
    this.getInternetUsage().forEach((usage, index) => {
      data.push(this.formattedInternetUsageData(index));
    });
    return data;
  }

  return object;
}

